import styled from 'styled-components';

export const SelectArrow = styled.div`
    width: 7px;
    height: 7px;
    transform: rotate(-45deg);
    border-left: solid 2px #3f5063;
    border-bottom: solid 2px #3f5063;

    &:hover {
        cursor: pointer;
    }
`;

export const SelectArrowContainer = styled.div`
    position: absolute;
    right: 5px;
    bottom: 2px;
    width: 6px;
    height: 6px;
    margin-bottom: 20px;
    z-index: 8;
`;